import React from 'react';
import { useEffect, useState } from 'react';
import { X } from 'lucide-react';

interface SaveAsWebappModalProps {
  onClose: () => void;
}

export default function SaveAsWebappModal({ onClose }: SaveAsWebappModalProps) {
  const [isChrome, setIsChrome] = useState(false);

  useEffect(() => {
    // Check if browser is Chrome
    const userAgent = navigator.userAgent.toLowerCase();
    setIsChrome(userAgent.includes('chrome') && !userAgent.includes('edg'));
  }, []);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-gray-800 rounded-lg w-full max-w-md">
        <div className="flex justify-between items-center p-4 border-b border-gray-700">
          <h2 className="text-xl font-bold text-white"> Mentor Community to Home Screen</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 space-y-4">
        <div className="space-y-6 w-full">
            <div className="space-y-2">
              <p className="text-sm font-medium text-white">Step 1: Click on share below</p>
              <img
                src= {isChrome ? "https://i.postimg.cc/KjX4DrSm/IMG-2260.jpg":"https://i.postimg.cc/kgJyFZ4m/Group-1-3.png"}
                alt="Step 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>

            <div className="space-y-2">
              <p className="text-sm font-medium text-white">Step 2: Click "Add to Home Screen"</p>
              <img
                src="https://i.postimg.cc/XvhcWYgj/Group-2.png"
                alt="Step 2"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          <button
            onClick={onClose}
            className="w-full bg-[#c9fffc] text-gray-900 rounded-lg px-4 py-2 font-medium hover:bg-[#a0fcf9] transition-colors"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
    </div>
  );
}